import React, { useState, useEffect } from 'react';

interface RotatingMessageProps {
  messages: string[];
  intervalMs?: number;
}

const RotatingMessage: React.FC<RotatingMessageProps> = ({ messages, intervalMs = 2000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (messages.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, intervalMs);

    return () => clearInterval(timer);
  }, [messages.length, intervalMs]);

  return <>{messages[currentIndex]}</>;
};

export default RotatingMessage;
